import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import Switches from "vue-switches";
import _ from "lodash";
// QUINLAN
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import UserModule from "@/store/modules/user.module";
import { toaster } from "@/utilities/toaster";
import Loader from "../../../components/widgets/loader.vue";
import EcSelect from "@/components/widgets/EcSelect.vue";
/**
 * Edit User Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let EditUser = /** @class */ (() => {
    let EditUser = class EditUser extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.pageIsLoading = true;
            this.title = "Edit User";
            this.selectedRole = null;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Users",
                    to: "/users",
                },
                {
                    text: "Edit User",
                    active: true,
                },
            ];
            this.ctaButtons = [
                {
                    routeName: "Users",
                },
            ];
        }
        //Computed
        get users() {
            return UserModule.user;
        }
        updateUser() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    this.pageIsLoading = true;
                    this.users.roles = [this.selectedRole];
                    UserModule.UpdateUser(this.users).then((response) => {
                        toaster.ShowSuccess("User was updated successfully.");
                        this.pageIsLoading = false;
                        this.$router.push({ name: "Users" });
                    });
                }
            });
        }
        get roles() {
            return UserModule.roles;
        }
        get organizations() {
            return UserModule.organizations;
        }
        get sortedRoles() {
            return _.sortBy(this.roles, (o) => o.value);
        }
        //Lifecycle
        created() {
            var userId = this.$route.params.userId;
            UserModule.GetUserDetailById(userId).then((response) => {
                if (this.users.roles && this.users.roles.length > 0) {
                    this.selectedRole = this.users.roles[0];
                }
                this.pageIsLoading = false;
            });
        }
    };
    EditUser = __decorate([
        Component({
            name: "EditUser",
            components: {
                Layout,
                PageHeader,
                Switches,
                Loader,
                EcSelect,
            },
        })
    ], EditUser);
    return EditUser;
})();
export default EditUser;
